"use strict";
/*
 * Created on 29.11.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author MSu
 */


var PromotionActionContext =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromotionActionContext, _DomainObject_1$Domai);

  // tslint:disable-next-line
  function PromotionActionContext(promotionId, actionType) {
    var _this;

    _classCallCheck(this, PromotionActionContext);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionActionContext).call(this));
    _this.promotionId = promotionId;
    _this.actionType = actionType;
    return _this;
  }

  return PromotionActionContext;
}(DomainObject_1.DomainObject);

exports.PromotionActionContext = PromotionActionContext;

PromotionActionContext.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromotionActionContext.name);
  return {
    promotionId: builder.str('promotionId'),
    actionType: builder.str('actionType')
  };
}();